import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicBoxAuthorizeResponse {
  @jsonMember(String)
  public readonly accessToken!: string;
}
